import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { card } from 'utils/common.styles';
import { BREAKPOINTS } from 'utils/constants';

export const BlockWrapper = styled.div<{ shouldUseCardStyles?: boolean }>`
  width: 400px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    width: calc(100% - 32px);
    margin-left: var(--spacing-l4);
    margin-right: var(--spacing-l4);
  }

  &:not(:last-child) {
    margin-bottom: var(--spacing-l8);
  }

  ${({ shouldUseCardStyles }) =>
    shouldUseCardStyles
      ? css`
          ${card};
          padding: var(--spacing-l2);
        `
      : ''}
`;
